import moment from "moment";
import Settings from "../constants/Settings";

export class StaffFixAlw {
    StaffID;
    DateEff;
    IncTypeDesc;
    IncSubType;
    Amt;
    constructor() {
        this.StaffID = "";
        this.DateEff = moment().format(Settings.DateTime.yyyymmdd);
        this.IncTypeDesc = "";
        this.IncSubType = "";
        this.Amt = 0
    }
}



// WEBPACK FOOTER //
// ./src/model/StaffFixAlw.js